import i18next from 'i18next';
import HttpApi, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { BASE_PATH, IS_TEST } from '../../../constants';

type Props = {
  useLocalTranslations: boolean;
};

export const i18FailureRetryCount = 1;

export const initI18Next = ({ useLocalTranslations }: Props) => {
  let LOAD_PATH = 'https://translations.hotjar.com/translations/{{ns}}/{{lng}}.i18n.json';

  if (useLocalTranslations) {
    LOAD_PATH = `${
      new URL(`${BASE_PATH}/locales`, window.location.origin).href
    }/{{ns}}/{{lng}}.i18n.json`;
  }

  i18next
    .use(HttpApi)
    .use(initReactI18next)
    .init<HttpBackendOptions>({
      maxRetries: i18FailureRetryCount,
      lng: 'en',
      ns: ['user-test', 'engage'],
      defaultNS: 'user-test',
      load: 'languageOnly',
      interpolation: {
        escapeValue: false,
      },
      fallbackLng: {
        'pt-STAGING': ['pt-BR', 'en'],
        'de-STAGING': ['de', 'en'],
        'es-STAGING': ['es', 'en'],
        default: ['en', 'en'],
      },
      backend: {
        loadPath: LOAD_PATH,
        crossDomain: true,
      },
      react: {
        bindI18n: 'languageChanged',
        transSupportBasicHtmlNodes: false,
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
        useSuspense: !IS_TEST,
      },
    });
};
